/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/** FONTAWESOME **/
// Disable Font Awesome's MutationObserver. The SVG/JS build otherwise watches
// the whole document and re-scans it on every DOM change to swap <i> tags for
// <svg>. On mutation-heavy pages (e.g. the overview, which AJAX-injects the
// invoices table and usage-advice reports and renders Highcharts SVG) this
// observer fires in a runaway scan/replace loop that pegs the main thread.
// Icons are still replaced once on initial load (autoReplaceSvg stays on);
// only the continuous re-scanning is turned off.
window.FontAwesomeConfig = { observeMutations: false };
require('@fortawesome/fontawesome-free/js/all');

// With the always-on observer disabled, icons injected into the DOM after the
// initial page render (e.g. AJAX-loaded tables, the usage-advice reports) would
// stay as unconverted <i> tags. Re-scan once per completed AJAX request instead.
// This runs only on ajaxComplete (not on every DOM mutation), and is debounced,
// so it converts freshly injected icons without re-introducing the runaway loop.
$(function () {
    let i2svgTimer = null;
    $(document).ajaxComplete(function () {
        if (! (window.FontAwesome && window.FontAwesome.dom))
        {
            return;
        }

        clearTimeout(i2svgTimer);
        i2svgTimer = setTimeout(function () {
            window.FontAwesome.dom.i2svg();
        }, 50);
    });
});

/** PLUGINS **/
window.Highcharts = require('highcharts/highstock');
require('highcharts/modules/map')(Highcharts);
require('highcharts/modules/drilldown')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
require('./_libs/bootstrap-touchspin/dist/jquery.bootstrap-touchspin');
require('bootstrap-datepicker/dist/js/bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl.min');

// input validation: https://github.com/nosir/cleave.js/
var Cleave;
Cleave = require('cleave.js/dist/cleave.min.js');
require('cleave.js/dist/addons/cleave-phone.nl.js');

/** CUSTOM GLOBAL JS **/
require('./global');

/** CUSTOM JS **/
require('./usage/usage');
require('./changes/changes');
require('./settings/settings');
require('./contracts/contracts');
require('./invoices/invoices');
require('./list-detail');
require('./salesperson/salesperson');
require('./auth/delete-account');
require('./authorize/get-status');
require('./admin/admin');
require('./debug');


// window.Vue = require('vue');
//
// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */
//
// // const files = require.context('./', true, /\.vue$/i);
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
//
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
//
// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */
//
// const app = new Vue({
//     el: '#app',
// });

$(function () {
    // Font Awesome replaces the <i> of an info icon with an <svg> on load and
    // copies the data attributes along; a popover bound to the <i> goes with
    // it, so bind after that replacement (and again for AJAX-injected icons)
    const initPopovers = function ()
    {
        $('[data-toggle="popover"]').not('.popover-ready').addClass('popover-ready').popover();
    };

    if (window.FontAwesome && window.FontAwesome.dom)
    {
        window.FontAwesome.dom.i2svg({ callback: initPopovers });
    }
    else
    {
        initPopovers();
    }

    $(document).ajaxComplete(function () {
        setTimeout(initPopovers, 100);
    });
});

// with dark mode on by hand the automatic switches no longer apply; following the
// system leaves the evening switch nothing to do as long as the browser reports a scheme
$(function () {
    const $manual = $('input#theme_dark');
    const $evening = $('input#theme_evening_dark');
    const $system = $('input#theme_system_dark');

    if (! $manual.length || ! $evening.length || ! $system.length)
    {
        return;
    }

    const reportsScheme = !! window.matchMedia
        && (window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(prefers-color-scheme: light)').matches);

    const setOff = function ($input, off)
    {
        $input.prop('disabled', off).closest('.form-group, .pretty').first().css('opacity', off ? 0.5 : '');
    };

    const sync = function ()
    {
        const manual = $manual.is(':checked');
        setOff($system, manual);
        setOff($evening, manual || ($system.is(':checked') && reportsScheme));
    };

    $manual.add($system).on('change', sync);
    // a disabled switch posts nothing and would be saved as "off"; keep the stored choice
    $manual.closest('form').on('submit', function () {
        $evening.add($system).prop('disabled', false);
    });
    sync();
});
